module.exports = __webpack_public_path__ + "img/caneca_blanca.f42460ed.png";